export const pagesMarkdownDA = {
  'service-og-vedligehold': `# Service og vedligehold af dine VVS-installationer

Et årligt eftersyn forlænger levetiden på dit varmeanlæg, sænker driftsomkostningerne og fanger fejl, før de bliver til dyre skader. Tegn en serviceaftale og slip for at huske det selv.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Serviceaftaler til private og erhverv

Med en serviceaftale kommer vi automatisk forbi én gang om året og gennemgår dit anlæg. Du får en fast lav pris på eftersynet, prioriteret udrykning ved fejl og rabat på reservedele.

| Serviceaftale | Indhold |
| --- | --- |
| Varmepumpe | Årligt eftersyn, lovpligtigt kølemiddelcheck, rensning af filtre og udedel, kontrol af drift |
| Fjernvarme | Eftersyn af unit, rensning af snavssamler, kontrol af afkøling og indregulering |
| Gasfyr | Lovpligtigt serviceeftersyn, rensning af brænder og kontrol af aftræk |
| Ventilation | Filterskift, rensning og kontrol af varmegenvinding |

Prisen på en serviceaftale afhænger af anlæg og omfang – kontakt os for et uforpligtende tilbud.

## Hvorfor vedligehold betaler sig

- Et serviceret varmeanlæg bruger typisk 5–10 % mindre energi
- Producentgarantien på varmepumper kræver ofte dokumenteret årligt eftersyn
- Slidte pakninger og ventiler opdages, før de giver vandskader
- Levetiden på anlægget forlænges med flere år

## VVS-eftersyn af hele boligen

Skal du sælge eller købe hus, eller er dine installationer bare gamle? Vi tilbyder et samlet VVS-eftersyn, hvor vi gennemgår vand, afløb, varme og varmt vand og giver dig en prioriteret liste over, hvad der bør gøres. Læs mere om [renovering af rørinstallationer](/vvs/roerinstallationer).

Er eftersyn af gasfyr lovpligtigt?

Ja, gasfyr skal efterses regelmæssigt af en autoriseret installatør – typisk hvert eller hvert andet år afhængigt af fyrets type.

Kan jeg opsige serviceaftalen?

Ja, aftalen løber ét år ad gangen og kan opsiges med en måneds varsel til udløb.`,

  'blikkenslager': `# Blikkenslager i Billund – tagrender, inddækninger og zinkarbejde

Vores blikkenslagere udfører alt inden for tagrender, nedløb, inddækninger og facadebeklædning i zink, kobber og aluminium – håndværk, der holder vand og vejr ude i årtier.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Blikkenslagerarbejde på tag og facade

Blikkenslagerfaget handler om at lede vandet det rigtige sted hen. Utætte tagrender, dårlige inddækninger ved skorsten og ovenlys eller rustne skotrender fører hurtigt til fugtskader i tagkonstruktionen. Vi laver både nyt og reparerer det gamle – på parcelhuse, landejendomme, erhvervsbygninger og ved nybyggeri.

## Vi tilbyder

- Nye tagrender og nedløbsrør i zink, kobber, aluminium og plast
- Rensning og reparation af eksisterende tagrender
- Inddækninger omkring skorsten, ovenlys, kviste og aftræk
- Skotrender og fodblik
- Zink- og kobbertage samt facadebeklædning
- Sålbænke, murafdækninger og vindskeder
- Aftrækshætter til ventilation og emhætte

## Zink, kobber eller alu?

| Materiale | Levetid | Kendetegn |
| --- | --- | --- |
| Zink | 40–60 år | Klassisk dansk udtryk, patinerer gråt, god pris |
| Kobber | 80–100+ år | Patinerer grønt, meget holdbart, højere pris |
| Aluminium | 30–40 år | Let, fås i farver, vedligeholdelsesfrit |
| Plast | 15–25 år | Billigst, egnet til udhuse og carporte |

## Smedearbejde

Ud over VVS og blik udfører vi mindre smedearbejde – rørføringer i stål, konsoller, beslag og reparationer i forbindelse med varme- og ventilationsinstallationer.

## Blikkenslager i Billund, Grindsted, Give og Vejle

Vi kører i hele Billund Kommune og omegn. Kombinerer du blikkenslagerarbejde med en tagrenovering, samarbejder vi gerne med din tømrer, så inddækningerne laves, mens stilladset alligevel står.

Hvad koster nye tagrender?

Det afhænger af materiale, taghøjde og adgangsforhold. Prisen varierer fra opgave til opgave, så vi giver dig gerne et [uforpligtende tilbud](/tilbud) efter en gratis besigtigelse.

Hvor tit skal tagrender renses?

Mindst én gang om året – helst efter løvfald. Står der store træer tæt på huset, gerne to gange.`,

  'om-os': `# Om Billund Varme & Sanitet A/S

Firmaet har eksisteret siden 1963. Mogens Brøgger blev uddannet VVS-installatør i 2011 og overtog firmaet i 2012 – og har i dag over 25 års erfaring i faget.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Din lokale VVS'er siden 1963

Billund Varme & Sanitet A/S har mange års erfaring med alle typer opgaver inden for VVS-faget. Vi hjælper alle – fra privatpersoner til virksomheder, foreninger og institutioner. Vi kan med andre ord hjælpe dig, uanset om du skal have ny varmeforsyning, renoveret rørinstallationerne eller bygget badeværelset om.

- **1963** grundlagt i Billund
- **60+** års erfaring med VVS
- **2012** overtaget af Mogens Brøgger
- **24/7** døgnvagt hele året

## Vi er først tilfredse, når kunden er tilfreds

Vores fokus er altid på at levere præcis det stykke arbejde, som den enkelte kunde har brug for. Ikke mere, ikke mindre. Det betyder ærlig rådgivning – også når det billigste er at reparere frem for at udskifte – og montører, der rydder op efter sig og holder de aftaler, vi laver.

## Autoriseret og forsikret

Billund Varme & Sanitet A/S er autoriseret VVS-installatør (CVR 29407320). Alt arbejde på vand-, afløbs- og gasinstallationer udføres af uddannede montører og dokumenteres, så du er sikret over for forsikring, kommune og en eventuel fremtidig køber af din bolig.

## Mogens Brøgger – indehaver og VVS-installatør

Mogens blev uddannet VVS-installatør i 2011 og overtog firmaet i 2012. Han står stadig selv for tilbud, besigtigelser og den daglige ledelse – og han er ikke bange for at tage værktøjet i hånden. Har du spørgsmål til en opgave, er det Mogens, du taler med.

## Det arbejder vi med

Vi udfører [VVS-arbejde](/vvs), [varmepumper](/varme/varmepumper), [fjernvarme](/varme/fjernvarme), [badeværelser](/vvs/badevaerelser), [blikkenslager- og smedearbejde](/blikkenslager), [nybyggeri](/nybyggeri) og [service](/service-og-vedligehold) i hele Billund Kommune og omegn. Se vores [referencer](/referencer), eller læs om [job og lærlingepladser](/karriere).`,

  'varme-varmepumper': `# Varmepumpe i Billund – installation, tilskud og service

En varmepumpe er den billigste og mest klimavenlige opvarmning for de fleste huse uden fjernvarme. Vi leverer komplette varmepumpeanlæg med efterfølgende service og professionel varmestyring.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Luft til vand-varmepumpe – erstat olie- eller gasfyret

En luft til vand-varmepumpe henter energi fra udeluften og leverer den til dine radiatorer, gulvvarme og varmt brugsvand. For hver kWh strøm, pumpen bruger, leverer den typisk 3–4 kWh varme. Skifter du fra oliefyr, kan besparelsen ligge på 40–60 % af den årlige varmeudgift.

- **3–4×** så meget varme som strømforbrug (SCOP)
- **40–60 %** lavere varmeregning end oliefyr
- **15–20 år** forventet levetid med service
- **1–2 dage** installationstid i et parcelhus

## Vi hjælper hele vejen

- Gratis besigtigelse og dimensionering ud fra husets varmebehov
- Rådgivning om valg af varmepumpe og placering af udedelen (støjkrav)
- Ansøgning om tilskud fra Energistyrelsens varmepumpepulje, når puljen er åben
- Demontering og bortskaffelse af gammelt fyr og olietank
- Installation, indregulering og instruktion i betjening
- Serviceaftale med årligt eftersyn og lovpligtigt kølemiddelcheck

## Luft til luft-varmepumpe til sommerhus og tilbygning

Til sommerhuse, værksteder og rum med elvarme er en luft til luft-varmepumpe ofte den bedste løsning. Den varmer om vinteren, køler om sommeren og er installeret på en halv dag.

## Hvad koster en varmepumpe?

Prisen afhænger af husets varmebehov, valg af varmepumpe og det eksisterende anlæg – og varierer derfor fra opgave til opgave. Vi beregner varmebehovet ved en gratis besigtigelse og giver dig et [uforpligtende tilbud](/tilbud) på netop dit hus. Læs også vores [guide til, hvad der påvirker prisen](/guides/hvad-koster-en-varmepumpe).

## Varmepumpe eller fjernvarme?

I dele af Billund og Grindsted er der mulighed for [fjernvarme](/varme/fjernvarme). Vi rådgiver neutralt om, hvad der bedst kan betale sig for dig – se sammenligningen i guiden [Fjernvarme eller varmepumpe?](/guides/fjernvarme-eller-varmepumpe)

Kan en varmepumpe klare et ældre hus med radiatorer?

Ja, i langt de fleste tilfælde. Vi beregner husets varmebehov og tjekker, om radiatorerne er store nok til den lavere fremløbstemperatur. Nogle gange skal en enkelt radiator skiftes.

Larmer en varmepumpe?

Moderne varmepumper støjer 35–45 dB(A) i nogle meters afstand. Vi placerer udedelen, så støjkravet mod naboskel overholdes.

Hvor tit skal en varmepumpe serviceres?

Vi anbefaler et årligt eftersyn. Anlæg med mere end 1 kg kølemiddel skal desuden efterses lovpligtigt hvert år af en certificeret montør – det er inkluderet i vores serviceaftale.`,

  'varme-varmeanlaeg': `# Varmeanlæg, gulvvarme og udskiftning af fyr

Vi installerer og renoverer alle typer varmeanlæg – radiatorer, gulvvarme, varmtvandsbeholdere og styring – og hjælper dig videre, når olie- eller gasfyret skal udfases.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Tid til at skifte olie- eller gasfyret?

Oliefyr må ikke længere installeres i områder med fjernvarme eller naturgas, og naturgas udfases frem mod 2035. Er dit fyr over 15 år, er det tid til at planlægge afløseren. Vi gennemgår mulighederne med dig – [varmepumpe](/varme/varmepumper), [fjernvarme](/varme/fjernvarme) eller i særlige tilfælde et nyt kondenserende gasfyr som overgangsløsning.

## Gulvvarme – komfort og lav fremløbstemperatur

Gulvvarme giver en jævn varme og passer perfekt sammen med varmepumpe og fjernvarme, fordi det kører ved lav temperatur. Vi lægger vandbåren gulvvarme i nybyggeri, tilbygninger og ved renovering af badeværelser og køkkener – både i beton og i lette gulvkonstruktioner.

## Radiatorer og varmtvandsbeholdere

- Udskiftning af gamle radiatorer til lavtemperaturradiatorer
- Termostatventiler og indregulering af hele anlægget
- Nye varmtvandsbeholdere og gennemstrømningsvandvarmere
- Cirkulationspumper med lavt energiforbrug
- Vejrkompensering og intelligent varmestyring

## Professionel varmestyring

Et korrekt indstillet varmeanlæg kan spare 10–15 % på varmeregningen uden at gå på kompromis med komforten. Vi indregulerer anlægget, indstiller varmekurve og tidsstyring og lærer dig at bruge styringen – også via app.

Kan jeg få tilskud til at skrotte mit oliefyr?

Energistyrelsen har løbende puljer til udskiftning af olie- og gasfyr med varmepumpe. Vi holder os opdateret og hjælper med ansøgningen, når puljen er åben.

Kan gulvvarme lægges oven på et eksisterende gulv?

Ja, med lavtbyggende gulvvarmesystemer på 15–30 mm. Det er en god løsning ved renovering, hvor det gamle gulv ikke skal brydes op.`,

  'vvs-ventilation': `# Ventilation og bedre indeklima

Vi installerer og renoverer ventilationsanlæg, så du kan få et godt indeklima – uden fugt, skimmel og dug på ruderne.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Ventilationsanlæg til bolig og erhverv

Moderne, tætte huse har brug for mekanisk ventilation for at komme af med fugt og CO₂. Et balanceret ventilationsanlæg med varmegenvinding skifter luften i hele boligen og genbruger op til 90 % af varmen i den brugte luft. Resultatet er frisk luft, lavere varmeregning og færre problemer med fugt og allergi.

## Det laver vi

- Balanceret ventilation med varmegenvinding i nybyggeri og eksisterende huse
- Udsugning fra køkken, bad og bryggers
- Ventilation i erhvervslokaler, institutioner og produktionsbygninger
- Filterskift, rensning og indregulering af eksisterende anlæg
- Decentrale ventilationsløsninger til enkeltrum

## Tegn på, at du mangler ventilation

Dug på indersiden af ruderne om morgenen, mug i badeværelsets fuger, tung luft i soveværelset og lugt, der hænger ved, er alle tegn på for lidt luftskifte. Bygningsreglementet stiller krav om et luftskifte på mindst 0,3 l/s pr. m² i nye boliger – det svarer til, at al luften i huset skiftes cirka hver anden time.

## Ventilation og varmepumpe hænger sammen

Overvejer du samtidig at skifte til [varmepumpe](/varme/varmepumper), er det oplagt at tænke ventilation ind fra starten. Et tæt, velisoleret hus med god ventilation giver varmepumpen de bedste betingelser og den laveste driftsomkostning.

Hvad koster et ventilationsanlæg til et parcelhus?

Det afhænger af husets størrelse, og hvor nemt kanalerne kan føres. Prisen varierer fra opgave til opgave, så vi giver dig gerne et [uforpligtende tilbud](/tilbud) efter en gratis besigtigelse.

Hvor ofte skal filtrene skiftes?

Som regel hver 6.–12. måned. Vi tilbyder en [serviceaftale](/service-og-vedligehold), hvor vi skifter filtre og efterser anlægget én gang om året.`,

  'erhverv': `# VVS til erhverv, boligforeninger og institutioner

Driftsstop koster penge. Som fast VVS-partner sørger vi for, at jeres installationer kører stabilt – med serviceaftale, fast montør og hurtig hjælp, når det haster.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Én VVS-partner til hele ejendomsporteføljen

Vi servicerer virksomheder, boligforeninger, ejerforeninger, udlejere og offentlige institutioner i Billund Kommune og omegn. Vores kunder tæller alt fra produktionsvirksomheder og hoteller omkring Billund til boligafdelinger i Grindsted og institutioner i Give.

## Det får I som erhvervskunde

- Fast tilknyttet montør, der kender jeres bygninger og installationer
- Serviceaftale med planlagte eftersyn af varme, vand, ventilation og varmtvandsanlæg
- Prioriteret udrykning ved driftstop – også uden for åbningstid
- Legionellaforebyggelse og temperaturlogning i varmtvandsanlæg
- Lovpligtige eftersyn af varmepumper og køleanlæg
- Renovering af stigstrenge, faldstammer og varmecentraler i etageejendomme
- Samlet fakturering og digital dokumentation pr. ejendom

## Boligforeninger og ejendomsadministration

Ved renovering af stigstrenge og badeværelser i beboede ejendomme er kommunikation med beboerne afgørende. Vi planlægger i etaper, varsler i god tid og sørger for midlertidig vandforsyning, så generne bliver mindst mulige.

## Industri og produktion

Til produktionsvirksomheder leverer vi procesrør, trykluft, køle- og varmeanlæg samt ventilation – og vi udfører arbejdet uden for produktionstid, når det kræves.

**Vil I have et tilbud på en serviceaftale?** Send en oversigt over jeres ejendomme og installationer til [info@billundvvs.dk](mailto:info@billundvvs.dk), så vender vi tilbage med et forslag.`,

  'varme-fjernvarme': `# Fjernvarme i Billund – tilslutning og fjernvarmeunit

Fjernvarme er nem, driftssikker og kræver minimal vedligeholdelse. Vi står for tilslutningen inde i huset, monterer fjernvarmeunit og sørger for, at anlægget kører optimalt.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Fjernvarmetilslutning fra A til Z

Når fjernvarmeselskabet har ført stikledningen ind til huset, overtager vi. Vi monterer fjernvarmeunit med veksler og varmtvandsbeholder eller gennemstrømningsvandvarmer, tilslutter det eksisterende radiator- eller gulvvarmeanlæg og fjerner det gamle olie- eller gasfyr.

## Vi tilbyder

- Montering af fjernvarmeunit – direkte eller indirekte anlæg
- Demontering og bortskaffelse af olie-, gas- eller pillefyr
- Indregulering af radiatorer og gulvvarme til lav returtemperatur
- Udskiftning af ældre fjernvarmeunits og varmevekslere
- Fejlfinding ved manglende varme eller varmt vand
- Serviceeftersyn og rensning af snavssamlere

## Undgå straftakst med lav returtemperatur

De fleste fjernvarmeværker afregner efter, hvor godt du afkøler vandet. Kører dit anlæg med høj returtemperatur, betaler du ekstra. En indregulering af radiatorventiler og korrekt indstilling af unitten kan spare flere tusinde kroner om året – og det er en af de mest oversete besparelser i fjernvarmeområder.

## Fjernvarme i Billund Kommune

Billund Varmeværk og Grindsted Varmeværk forsyner store dele af byerne, og fjernvarmenettet udbygges løbende. Ligger dit hus uden for forsyningsområdet, er en [varmepumpe](/varme/varmepumper) typisk det bedste alternativ. Se vores sammenligning: [Fjernvarme eller varmepumpe?](/guides/fjernvarme-eller-varmepumpe)

Hvad koster det at få installeret fjernvarme inde i huset?

Det afhænger af unit, det eksisterende anlæg og om det gamle fyr skal fjernes. Prisen varierer fra opgave til opgave, så vi giver dig gerne et [uforpligtende tilbud](/tilbud) efter en gratis besigtigelse. Tilslutningsbidrag til værket kommer oveni.

Skal min varmtvandsbeholder skiftes?

Ikke nødvendigvis. Er beholderen under 10 år og i god stand, kan den ofte genbruges. Vi vurderer det ved besigtigelsen.`,

  'faq': `# Ofte stillede spørgsmål

Her har vi samlet svar på de spørgsmål, vi oftest får fra kunder i Billund og omegn. Finder du ikke svar, så ring til os på 75 33 12 76.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Priser og tilbud

Hvad koster en VVS'er i timen?

Vi oplyser altid vores timepris, inden vi starter, og kørsel i Billund Kommune er inkluderet. Større opgaver tilbydes til fast pris efter en gratis besigtigelse.

Er tilbuddet bindende for mig?

Nej. Et tilbud fra os er gratis og uforpligtende. Først når du accepterer det, har vi en aftale.

Kan jeg få håndværkerfradrag?

Arbejdsløn til en række VVS-opgaver er omfattet af servicefradraget. Vi opdeler fakturaen i arbejdsløn og materialer, så du nemt kan indberette.

## Varme

Hvornår skal jeg skifte mit olie- eller gasfyr?

Er fyret over 15 år, bør du planlægge udskiftning. Se mulighederne under [varmeanlæg](/varme/varmeanlaeg), og læs guiden [Fjernvarme eller varmepumpe?](/guides/fjernvarme-eller-varmepumpe)

Hvor meget kan jeg spare med en varmepumpe?

Typisk 40–60 % i forhold til oliefyr og 20–40 % i forhold til naturgas. Se [prisguiden](/guides/hvad-koster-en-varmepumpe).

Hvorfor har jeg ikke varmt vand?

Ofte er det en defekt cirkulationspumpe, en kalket beholder eller en fejl på fyret. Ring til os – de fleste fejl rettes på første besøg.

## Akutte skader

Hvad gør jeg ved et sprængt rør?

Luk for hovedhanen ved vandmåleren, og ring til vores [døgnvagt](/vvs/akut-vvs) på 75 33 12 76.

Dækker forsikringen vandskader?

Pludselige skader som rørsprængninger dækkes som regel. Skader fra langsom udsivning dækkes sjældent. Vi leverer den dokumentation, forsikringen skal bruge.

## Praktisk

Hvor arbejder I?

I hele Billund Kommune – [Billund](/vvs-billund), [Grindsted](/vvs-grindsted), [Sdr. Omme, Vorbasse, Hejnsvig](/vvs-soender-omme) – samt [Give](/vvs-give) og [Vejle](/vvs-vejle).

Er I autoriserede?

Ja. Billund Varme & Sanitet A/S er autoriseret VVS-installatør, CVR 29407320.

Hvad er jeres åbningstider?

Mandag–torsdag 7.00–16.00, fredag 7.00–13.00. Døgnvagt alle dage.`,

  'guides-fjernvarme-eller-varmepumpe': `# Fjernvarme eller varmepumpe?

Bor du i et område med fjernvarme, er valget ikke altid oplagt. Her sammenligner vi de to løsninger på de punkter, der betyder noget for din økonomi og komfort.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Sammenligning

| Egenskab | Fjernvarme | Luft til vand-varmepumpe |
| --- | --- | --- |
| Investering | Unit + tilslutningsbidrag til værket | Højere anskaffelse – tilskud kan søges |
| Årlig varmeudgift | Afhænger af værkets takst | Afhænger af elpris og husets isolering |
| Vedligehold | Minimalt – årligt eftersyn anbefales | Årligt serviceeftersyn |
| Levetid | Unit 20–25 år | 15–20 år |
| Plads | Lille unit på væggen | Udedel i haven + indedel/beholder |
| Støj | Ingen | 35–45 dB(A) fra udedel |
| Klima | Afhænger af værkets brændsel | Grøn i takt med elnettet |

## Vælg fjernvarme, hvis …

- Dit hus ligger i forsyningsområdet for Billund eller Grindsted Varmeværk
- Du vil have en løsning uden vedligehold og støj
- Du har lille grund eller naboer tæt på

## Vælg varmepumpe, hvis …

- Fjernvarme ikke er tilgængelig – eller først om mange år
- Dit hus er rimeligt isoleret og har gulvvarme eller store radiatorer
- Du har eller planlægger solceller
- Du kan opnå tilskud fra varmepumpepuljen

## Vores anbefaling

Er fjernvarme tilgængelig inden for 1–2 år, er det for de fleste den enkleste løsning. Er der ikke fjernvarme på vej, er en varmepumpe klart det bedste valg. Vi rådgiver neutralt – vi installerer begge dele. Læs mere om [fjernvarme](/varme/fjernvarme) og [varmepumper](/varme/varmepumper), eller [bestil en besigtigelse](/tilbud).`,

  'nybyggeri': `# VVS i alle former for nybyggeri

Vi udfører komplette VVS-installationer i nybyggeri – fra boliger og erhvervsbyggeri til større byggerier og offentlige institutioner. Til tiden, efter tegningerne og med fuld dokumentation.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

![Rækkehusbyggeri under opførelse – VVS-installationer af Billund Varme & Sanitet](/_assets/nybyg.jpg)

## Fast VVS-partner for entreprenører, typehusfirmaer og bygherrer

Nybyggeri stiller krav til planlægning, dokumentation og præcision. Vores montører er vant til at arbejde efter tidsplaner med mange fag på pladsen, og vi leverer den dokumentation, byggesagen kræver – trykprøvningsrapporter, KS-materiale og as-built-tegninger.

## Det leverer vi i nybyggeri

- Vand-, afløbs- og sanitetsinstallationer
- Gulvvarme, radiatorer og varmecentraler
- Varmepumper og fjernvarmetilslutning
- Balanceret ventilation med varmegenvinding
- Tagrender, inddækninger og blikarbejde
- Sprinkler- og teknikrum i samarbejde med specialister

## Fra parcelhus til institution

### Boliger
Parcelhuse, rækkehuse, sommerhuse og etageboliger – i samarbejde med typehusfirmaer og private bygherrer.

### Erhverv
Lager, produktion, kontorer og butikker – herunder de mange erhvervsbyggerier omkring Billund Lufthavn.

### Offentlige institutioner
Skoler, daginstitutioner, plejecentre og idrætsanlæg med krav om legionellasikring og drift.

### Landbrug
Driftsbygninger og teknikrum med robuste installationer til krævende miljøer.

## Sådan arbejder vi i byggeprojekter

1. **Tilbud på baggrund af tegninger** Vi regner på udbudsmaterialet og foreslår optimeringer, hvor det giver mening.
2. **Projektering og koordinering** Fast kontaktperson, der deltager i byggemøder og koordinerer med øvrige fag.
3. **Udførelse i etaper** Råhusinstallationer, montage og aflevering efter tidsplanen.
4. **Dokumentation og aflevering** Trykprøvning, KS, drifts- og vedligeholdelsesmateriale.

Efter afleveringen tilbyder vi [serviceaftaler](/service-og-vedligehold), så anlæggene holder deres ydelse i hele bygningens levetid. Se udvalgte projekter under [referencer](/referencer).`,

  'vvs-billund': `# VVS'er i Billund – vi holder til lige om hjørnet

Billund Varme & Sanitet A/S har adresse på Montanavej 1B i Billund. Herfra servicerer vi byens parcelhuse, boligforeninger, erhvervsområderne ved lufthavnen og alt derimellem.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Lokal VVS-installatør i Billund siden 1963

Vi har været en del af Billund, siden byen for alvor begyndte at vokse. Det betyder, at vi kender husene, installationerne og de lokale forhold – fra 1960'er-parcelhusene på Skolevej-kvarteret til de nyeste udstykninger og erhvervsbyggerierne omkring Billund Lufthavn og Lalandia.

## VVS-ydelser i Billund

- [Alt VVS-arbejde](/vvs) – haner, toiletter, rør og afløb
- [Badeværelser](/vvs/badevaerelser) til fast pris
- [Varmepumper](/varme/varmepumper) og [fjernvarme](/varme/fjernvarme) fra Billund Varmeværk
- [Blikkenslagerarbejde](/blikkenslager) – tagrender og inddækninger
- [Akut VVS med døgnvagt](/vvs/akut-vvs) – vi er fremme på få minutter

## Erhverv i Billund

Billund er hjemsted for nogle af Danmarks største arbejdspladser og et stort antal hoteller, feriecentre og transportvirksomheder. Vi leverer [serviceaftaler og drift](/erhverv) til erhvervsejendomme i hele byen og er vant til at arbejde i drift, uden at det går ud over gæster og produktion.

## Find os

Montanavej 1B, 7190 Billund – i erhvervsområdet ved Vejlevej, 5 minutter fra centrum. Der er parkering ved døren, hvis du vil forbi og se på armaturer eller aflevere en nøgle.`,

  'vvs-akut-vvs': `# Akut VVS-hjælp i Billund – døgnvagt 24/7

Vandet fosser, afløbet er stoppet, eller fyret er gået ud midt om natten? Ring 75 33 12 76. Vores vagtmontør rykker ud døgnet rundt i hele Billund Kommune.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

Døgnvagt: [75 33 12 76](tel:+4575331276)

Alle dage, hele året. Uden for normal åbningstid tillægges vagttillæg – vi oplyser prisen i telefonen, inden vi kører.

## Det rykker vi ud til

- Sprængte eller utætte vandrør og radiatorer
- Stoppede afløb, toiletter og faldstammer
- Varmesvigt – fyr, varmepumpe eller fjernvarmeunit, der ikke virker
- Utæt varmtvandsbeholder eller manglende varmt vand
- Frostsprængninger om vinteren
- Gaslugt – ring altid først til 112, dernæst til os

## Mens du venter på montøren

1. **Luk for vandet** Hovedhanen sidder ved vandmåleren. Ved utæt radiator: luk begge ventiler på radiatoren.
2. **Sluk for strømmen til fyret** Hvis det drypper ned på elektriske installationer.
3. **Tag billeder** Din forsikring vil bede om dokumentation af skaden.

## Hurtig udrykning i hele området

Fra vores adresse i Billund er der under 20 minutter til Grindsted, Give, Sdr. Omme og Vorbasse – og omkring 30 minutter til Vejle. Vi kører med fuldt udstyrede servicebiler, så de fleste akutte skader kan udbedres på første besøg.

Læs også vores guide: [Sådan undgår du frostsprængte rør](/guides/frostspraengte-roer).

Hvad koster akut VVS-hjælp?

Vi oplyser altid timepris og vagttillæg i telefonen, inden vi kører. Der er ingen skjulte gebyrer.

Kommer I også i weekenden og på helligdage?

Ja. Døgnvagten dækker alle dage hele året.`,

  'vvs-roerinstallationer': `# Rørinstallationer og udbedring af vandskader

Gamle jernrør, utætte samlinger og skjulte lækager koster dyrt. Vi renoverer rørinstallationer i alle typer bygninger og hjælper hurtigt, når skaden er sket.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Renovering af rørinstallationer i ældre boliger

Mange huse i Billund, Grindsted og Give fra 1960'erne og 70'erne har stadig de oprindelige vandrør. Efter 40–50 år tærer jern- og kobberrør, og risikoen for lækager stiger markant. Vi kan renovere alle slags VVS-installationer – og vi rådgiver ærligt om, hvorvidt det kan betale sig at udskifte alt på én gang eller i etaper.

## Vi hjælper med

- Udskiftning af vandrør til moderne PEX- eller kobberrør
- Nye stigstrenge og fordelerrør i etageejendomme og boligforeninger
- Udskiftning af afløbsrør og faldstammer
- Lækagesporing med trykprøvning og termografi
- Udbedring af vandskader i samarbejde med dit forsikringsselskab
- Montering af vandstopventil og lækagealarm

## Vandskade? Sådan gør du

1. **Luk for hovedhanen** Den sidder typisk ved vandmåleren i bryggers eller teknikrum.
2. **Ring til os på 75 33 12 76** Vi har døgnvagt og rykker ud til akutte skader i hele Billund Kommune.
3. **Kontakt dit forsikringsselskab** Vi leverer dokumentation og skadesrapport, som forsikringen skal bruge.

## Forebyg vandskader

En vandstopventil lukker automatisk for vandet ved unormalt forbrug. Kombineret med et årligt [VVS-eftersyn](/service-og-vedligehold) reducerer det risikoen for dyre skader betydeligt – og flere forsikringsselskaber giver rabat på præmien.

Hvornår bør vandrør udskiftes?

Jernrør bør som hovedregel udskiftes efter 40–50 år, og altid hvis der er tegn på rust i vandet, faldende vandtryk eller fugtpletter.

Dækker forsikringen en vandskade?

Pludselige skader som rørsprængninger dækkes normalt af husforsikringen. Skader fra langsom udsivning dækkes sjældent, hvilket er endnu en grund til at få installationerne tjekket.`,

  'privatlivspolitik': `# Privatlivspolitik

Billund Varme & Sanitet A/S (CVR 29407320) er dataansvarlig for de oplysninger, du afgiver via denne hjemmeside eller i forbindelse med opgaver, vi udfører for dig.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Hvilke oplysninger indsamler vi?

Navn, adresse, telefonnummer, e-mail og oplysninger om den opgave, du henvender dig om. Oplysningerne bruges udelukkende til at besvare din henvendelse, udarbejde tilbud, udføre opgaven og fakturere.

## Opbevaring

Oplysninger om udført arbejde opbevares i 5 år efter regnskabsårets udløb i henhold til bogføringsloven. Henvendelser, der ikke fører til en opgave, slettes efter 12 måneder.

## Cookies

Hjemmesiden anvender kun nødvendige cookies samt – med dit samtykke – statistikcookies til at forbedre siden.

## Dine rettigheder

Du kan til enhver tid få indsigt i, rettet eller slettet dine oplysninger ved at kontakte os på [info@billundvvs.dk](mailto:info@billundvvs.dk). Klager kan rettes til Datatilsynet.`,

  'vvs': `# Autoriseret VVS-installatør i Billund

Det er vigtigt at have velfungerende VVS-installationer i hjemmet og i virksomheden. Vi installerer, renoverer og servicerer alle typer VVS – med fast pris og garanti.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Alt VVS-arbejde fra én autoriseret installatør

Billund Varme & Sanitet A/S har mange års erfaring med alle typer opgaver inden for VVS-faget. Vi hjælper både privatpersoner, virksomheder, foreninger og institutioner – og vi kan renovere alle slags VVS-installationer, fra en enkelt utæt hane til komplette rørføringer i nybyggeri.

- [**Badeværelser** \\\\\nTotalrenovering, nyt bad eller bruseniche – vi styrer hele projektet.](/vvs/badevaerelser)
- [**Rørinstallationer & vandskader** \\\\\nNye vandrør, udskiftning af gamle installationer og udbedring af skader.](/vvs/roerinstallationer)
- [**Ventilation & indeklima** \\\\\nInstallation og renovering af ventilationsanlæg til bolig og erhverv.](/vvs/ventilation)
- [**Akut VVS – døgnvagt** \\\\\nSprængte rør, stoppet afløb eller varmesvigt? Vi rykker ud 24/7.](/vvs/akut-vvs)
- [**Varmepumper** \\\\\nLuft til vand- og luft til luft-varmepumper med service og tilskud.](/varme/varmepumper)
- [**Fjernvarme** \\\\\nTilslutning, fjernvarmeunit og optimering af dit anlæg.](/varme/fjernvarme)

## Typiske VVS-opgaver, vi løser hver dag

- Udskiftning af vandhaner, blandingsbatterier, toiletter og håndvaske
- Nye vand- og afløbsinstallationer i køkken og bryggers
- Montering af opvaskemaskine, vaskemaskine og køleskab med isvand
- Udskiftning af varmtvandsbeholder og cirkulationspumpe
- Radiatorer, gulvvarme og termostater
- Lovpligtige eftersyn og trykprøvning af installationer

## Undgå vandskader – få dine installationer gennemgået

Vandskader er blandt de dyreste skader i danske hjem. Vi kan gennemgå dine installationer, så eventuelle problemer kan udbedres i tide. Et VVS-eftersyn tager typisk 1–2 timer og giver dig en klar oversigt over, hvad der bør udskiftes nu, og hvad der kan vente.

## Spar på regningen med moderne installationer

Gamle installationer bruger unødigt meget vand og energi. Vandbesparende armaturer, en ny cirkulationspumpe eller en korrekt indreguleret varmeinstallation betaler sig ofte hjem på få år. Vi rådgiver altid ud fra, hvad der giver mening i netop din bolig – ikke ud fra, hvad der giver os mest at lave.

**Fast pris på tilbud.** Du er altid velkommen til at kontakte os for et uforpligtende tilbud. Mindre opgaver udføres efter medgået tid til gældende timepris, større opgaver til fast pris.

## Ofte stillede spørgsmål om VVS-arbejde

Hvad koster en VVS'er i timen i Billund?

Vores timepris for VVS-arbejde oplyses altid inden opstart, og kørsel inden for Billund Kommune er inkluderet. Større opgaver som badeværelser og varmepumper tilbydes til fast pris.

Skal VVS-arbejde udføres af en autoriseret installatør?

Ja. Arbejde på vand-, afløbs- og gasinstallationer må kun udføres af en autoriseret VVS-installatør. Billund Varme & Sanitet A/S er autoriseret, og du får dokumentation på det udførte arbejde.

Hvor hurtigt kan I komme?

Ved akutte skader rykker vi ud døgnet rundt. Planlagte opgaver kan typisk påbegyndes inden for 1–2 uger.`,

  'karriere': `# Job og lærlingepladser

Vi er et lokalt firma med varierede opgaver, faste kunder og en flad struktur, hvor du taler direkte med chefen. Vi søger løbende dygtige VVS-montører og lærlinge.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## VVS-montør

Du er udlært VVS'er, kan arbejde selvstændigt og har lyst til en hverdag med både servicekørsel, badeværelser, varmepumper og nybyggeri. Du får egen servicebil, moderne værktøj og mulighed for efteruddannelse inden for varmepumper, fjernvarme og ventilation.

## VVS-lærling

Vi tager lærlinge ind, fordi vi tror på at uddanne fremtidens fagfolk lokalt. Som lærling hos os kommer du hele vejen rundt i faget og får en fast svend som mentor. Vi samarbejder med erhvervsskolerne i Vejle og Esbjerg.

## Det tilbyder vi

- Løn efter overenskomst og pension
- Servicebil, telefon og arbejdstøj
- Varierede opgaver – aldrig to ens dage
- Kort vej fra idé til beslutning
- Fredag fri kl. 13

**Send en uopfordret ansøgning** til [info@billundvvs.dk](mailto:info@billundvvs.dk) – eller ring til Mogens på 75 33 12 76 og tag en snak.`,

  'vvs-vejle': `# VVS-installatør til Vejle og omegn

Vejle ligger 30 minutter fra Billund, og vi løser løbende opgaver i Vejle Vest, Jelling, Bredsten, Skibet og Vandel – især større projekter, badeværelser og erhvervsopgaver.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Hvorfor vælge en VVS'er fra Billund til opgaver i Vejle?

Fordi du får en fast pris, en fast montør og et firma, der har eksisteret siden 1963. Vi kører gerne til Vejle til planlagte opgaver – kørslen er inkluderet i tilbuddet, så prisen er den samme, som hvis vi var nabo.

## Opgaver, vi løser i Vejle-området

- [Badeværelsesrenovering](/vvs/badevaerelser) som totalentreprise
- [Varmepumper](/varme/varmepumper) til boliger uden fjernvarme i Vejle Ådal og Vejle Vest
- [VVS i nybyggeri](/nybyggeri) – vi er fast partner for flere byggefirmaer i Trekantområdet
- [Erhvervsservice](/erhverv) og serviceaftaler på ejendomme i Vejle
- [Blikkenslagerarbejde](/blikkenslager) – zinktage og tagrender

## Akut hjælp i Vejle

Ved akutte skader betjener vi primært Billund Kommune, men ring altid – er vagtmontøren i nærheden, kører vi også til Vejle. Se [akut VVS](/vvs/akut-vvs).`,

  'guides-hvad-koster-en-varmepumpe': `# Hvad koster en varmepumpe i 2026?

Kort svar: Det varierer fra hus til hus. Her gennemgår vi, hvad der påvirker prisen på en varmepumpe, hvilke tilskud du kan søge, og hvordan du får et præcist tilbud.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Det påvirker prisen

- **Husets varmebehov.** Et velisoleret hus på 130 m² kan klare sig med en 6 kW-pumpe; et ældre hus på 200 m² skal bruge 12–16 kW.
- **Varmt brugsvand.** Beholderstørrelse afhænger af husstandens størrelse.
- **Eksisterende anlæg.** Radiatorer, der er for små til lav fremløbstemperatur, skal måske skiftes.
- **Fjernelse af gammelt fyr og olietank.** Skal den gamle olietank sløjfes, indgår det i tilbuddet.
- **Placering af udedelen.** Lange rørføringer og fundament påvirker prisen.

## Hvad koster det så?

Fordi alle husene er forskellige, giver vi ikke standardpriser. Prisen varierer fra opgave til opgave, og derfor kommer vi altid ud og besigtiger huset, før vi giver et [uforpligtende tilbud](/tilbud) med fast pris – så du ved præcis, hvad du får, og hvad det koster.

## Tilskud

Energistyrelsen åbner løbende puljer med tilskud til udskiftning af olie- og gasfyr med varmepumpe. Beløbet afhænger af husets størrelse og nuværende varmekilde. Puljerne bliver hurtigt brugt op, så det er vigtigt at have tilbud og dokumentation klar, inden puljen åbner. Vi hjælper med hele ansøgningen.

## Driftsomkostninger og tilbagebetalingstid

En varmepumpe leverer typisk 3–4 gange så meget varme, som den bruger strøm. Skifter du fra oliefyr, ligger besparelsen på varmeregningen ofte på 40–60 % om året, og med tilskud og den lavere elafgift på varmepumpestrøm er investeringen for de fleste tjent hjem inden for en overskuelig årrække. Vi laver gerne en konkret beregning for dit hus.

Vil du vide, hvad det koster i dit hus? [Bestil en gratis besigtigelse](/tilbud), så beregner vi varmebehovet og giver en fast pris.

Læs mere om [vores varmepumpeløsninger](/varme/varmepumper), eller sammenlign med [fjernvarme](/guides/fjernvarme-eller-varmepumpe).`,

  'vvs-grindsted': `# VVS-installatør i Grindsted

Grindsted er kommunens største by, og vi er her dagligt. Fra Billund er der under et kvarter til Grindsted, så du får hurtig hjælp og en lokal montør, der kender byens ejendomme.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## VVS-arbejde i Grindsted og omegn

Vi udfører alle former for VVS-, varme- og blikkenslagerarbejde i Grindsted – for private, boligforeninger, institutioner og erhverv. Grindsted har mange ældre etageejendomme og boligafdelinger, hvor vi renoverer stigstrenge, faldstammer og badeværelser i beboede bygninger.

## Populære ydelser i Grindsted

- [Fjernvarmetilslutning](/varme/fjernvarme) og udskiftning af units i Grindsted Varmeværks forsyningsområde
- [Varmepumper](/varme/varmepumper) i landområderne omkring Grindsted, hvor der ikke er fjernvarme
- [Badeværelsesrenovering](/vvs/badevaerelser) i parcelhuse og lejligheder
- [Serviceaftaler](/erhverv) til boligforeninger, skoler og plejecentre
- [Akut VVS](/vvs/akut-vvs) – døgnvagt alle dage

## Landbrug og erhverv ved Grindsted

Oplandet omkring Grindsted er præget af landbrug og produktionsvirksomheder. Vi leverer robuste installationer til driftsbygninger og teknikrum og har erfaring med de særlige krav i industri og fødevareproduktion.

Læs også om vores arbejde i [Billund](/vvs-billund), [Give](/vvs-give) og [Sdr. Omme og Vorbasse](/vvs-soender-omme).`,

  'vvs-soender-omme': `# VVS i Sdr. Omme, Vorbasse og Hejnsvig

Vi dækker alle Billund Kommunes mindre byer og landområder – Sdr. Omme, Vorbasse, Hejnsvig, Stenderup-Krogager og Filskov – med samme service og samme pris som i Billund.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## VVS til land og by

Uden for de store byer er mange boliger og landbrug afhængige af egne installationer: varmepumpe eller fyr, egen vandforsyning og septiktank. Vi kender de udfordringer, det giver, og kører dagligt i hele kommunen.

## Det hjælper vi med

- [Udskiftning af oliefyr til varmepumpe](/varme/varmepumper) – med tilskud
- Hydroforanlæg, vandbehandling og egen vandforsyning
- Installationer til drifts- og landbrugsbygninger
- [Badeværelser](/vvs/badevaerelser) og [rørrenovering](/vvs/roerinstallationer) i ældre stuehuse
- [Tagrender og inddækninger](/blikkenslager) på landejendomme
- [Døgnvagt](/vvs/akut-vvs) – også ude på landet

## Vorbasse og Hejnsvig

Fra Billund er der 15 minutter til Vorbasse og 10 minutter til Hejnsvig. Vi har mange faste kunder i begge byer, både private og landbrug, og vi kender de lokale forhold – herunder de områder, hvor fjernvarme ikke er en mulighed.

## Sdr. Omme og Filskov

I Sdr. Omme og Filskov servicerer vi både parcelhuse, virksomheder og institutioner. Kontakt os for [et uforpligtende tilbud](/tilbud), uanset om det gælder en dryppende hane eller et helt nyt varmeanlæg.`,

  'guides': `# Guides og gode råd

Vi deler gerne ud af vores viden. Her finder du guides om varme, vand og vedligehold, skrevet af vores egne VVS-installatører.

- [Varme · 5 min **Hvad koster en varmepumpe i 2026?** \\\\\nHvad der påvirker prisen, hvilke tilskud du kan søge, og hvordan du får et præcist tilbud.](/guides/hvad-koster-en-varmepumpe)
- [Vinter · 3 min **Sådan undgår du frostsprængte rør** \\\\\nFem forholdsregler inden frosten – og hvad du gør, hvis skaden er sket.](/guides/frostspraengte-roer)
- [Varme · 6 min **Fjernvarme eller varmepumpe?** \\\\\nSådan vælger du den rigtige varmekilde i Billund Kommune.](/guides/fjernvarme-eller-varmepumpe)`,

  'guides-frostspraengte-roer': `# Sådan undgår du frostsprængte rør

Når vandet i et rør fryser, udvider det sig med cirka 9 %. Det er nok til at sprænge både kobber- og plastrør. Her er fem ting, du kan gøre, inden frosten kommer.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## 1. Luk og tøm udendørs haner

Luk for stophanen inde i huset, åbn den udvendige hane, og lad den stå åben hele vinteren. Har du ikke en stophane, kan vi montere en frostsikker udendørs hane.

## 2. Isolér rør i kolde rum

Rør i uopvarmede krybekældre, garager, udhuse og på lofter bør isoleres med rørskåle. Ved udsatte steder kan et varmekabel med termostat være nødvendigt.

## 3. Hold varmen på – også når du er væk

Sæt aldrig termostaterne lavere end frostsikring (ca. 8–10 °C), når du rejser om vinteren. Lad døren til bryggers og badeværelse stå på klem, så varmen når rørene.

## 4. Vinterluk sommerhuset korrekt

Luk for hovedhanen, tøm rør, varmtvandsbeholder, toiletcisterne og vandlåse, og hæld frostvæske i afløbene. Vi tilbyder vinterlukning som fast service i sommerhusområderne omkring Give og Vejle.

## 5. Kend din hovedhane

Alle i husstanden bør vide, hvor hovedhanen sidder, og hvordan den lukkes. Det kan begrænse en skade fra tusindvis til hundredvis af kroner.

## Hvis skaden er sket

1. **Luk for hovedhanen** Og åbn en hane, så trykket tages af.
2. **Ring til døgnvagten** [Akut VVS](/vvs/akut-vvs) – 75 33 12 76, alle dage.
3. **Dokumentér skaden** Tag billeder til forsikringen, inden du tørrer op.`,

  'vvs-give': `# VVS-installatør i Give

Give ligger 20 minutter fra vores værksted i Billund, og vi har haft kunder i byen og på landet omkring Give i årtier. Vi kommer, når vi siger, vi kommer.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## VVS, varme og blik i Give

Vi hjælper husejere, landbrug, virksomheder og institutioner i Give, Thyregod, Vonge, Givskud og omegn med alt inden for VVS. Mange huse i området er uden fjernvarme, så udskiftning af olie- og gasfyr til [varmepumpe](/varme/varmepumper) er en af de opgaver, vi løser oftest i Give.

## Det hjælper vi med i Give

- [Luft til vand-varmepumper](/varme/varmepumper) inkl. ansøgning om tilskud
- [Gulvvarme og nye varmeanlæg](/varme/varmeanlaeg)
- [Nye badeværelser](/vvs/badevaerelser) til fast pris
- [Tagrender og inddækninger](/blikkenslager) på parcelhuse og landejendomme
- [Rørrenovering og vandskader](/vvs/roerinstallationer)
- [Akut VVS](/vvs/akut-vvs) – vi rykker ud døgnet rundt

## Sommerhuse og fritidsboliger

Til sommerhusene omkring Give og ved Vejle Ådal monterer vi luft til luft-varmepumper, frostsikrer installationer og tilbyder vinterlukning og forårsåbning som fast service.`,

  'referencer': `# Referencer – udvalgte projekter

Et udvalg af de opgaver, vi har løst for private, boligforeninger, erhverv og offentlige institutioner i Billund Kommune og omegn.

[Skal vi også hjælpe dig? Få et tilbud →](/tilbud)

## Udvalgte projekter

### 24 rækkehuse med gulvvarme og ventilation
**Nybyggeri · Billund**
Komplet VVS-entreprise inkl. balanceret ventilation og fjernvarmetilslutning for typehusfirma.

### Totalrenovering af badeværelse fra 1972
**Badeværelse · Grindsted**
Nyt afløb, gulvvarme, vådrumssikring, fliser og walk-in-bruser – afleveret på 4 uger til fast pris.

### Fra oliefyr til luft til vand-varmepumpe
**Varmepumpe · Give**
Parcelhus på 165 m². Tilskud søgt og bevilget, olietank sløjfet og mærkbart lavere varmeregning.

### Serviceaftale på hotel med 120 værelser
**Erhverv · Billund**
Legionellasikring, varmtvandsanlæg og ventilation. Fast montør og kvartalsvise eftersyn.

### Udskiftning af stigstrenge i 36 lejligheder
**Boligforening · Grindsted**
Etapevis renovering i beboet ejendom med midlertidig vandforsyning og daglig beboerinformation.

### Zinktag og inddækninger på villa
**Blikkenslager · Vejle**
Nyt ståfalset zinktag på kvist, skotrender og tagrender i zink i samarbejde med lokal tømrer.`,

  'vvs-badevaerelser': `# Nyt badeværelse i Billund – renovering til fast pris

Et nyt badeværelse er en af de bedste investeringer i din bolig. Vi står for hele renoveringen – fra VVS og afløb til fliser, el og montering – med ét kontaktpunkt og én fast pris.

[Få et uforpligtende tilbud](/tilbud) [Ring 75 33 12 76](tel:+4575331276)

## Badeværelsesrenovering med VVS-fagmanden som totalentreprenør

Når vi renoverer dit badeværelse, koordinerer vi alle fag. Du får én kontaktperson, én tidsplan og ét samlet tilbud. Vores egne VVS-montører står for vand, afløb, gulvvarme og sanitet, mens vi samarbejder med faste lokale murere, elektrikere og tømrere fra Billund-området.

## Det får du med i et badeværelse fra os

- Gratis besigtigelse og rådgivning om indretning og materialer
- Nedrivning og bortskaffelse af det gamle badeværelse
- Nye vand- og afløbsinstallationer efter gældende bygningsreglement
- Vådrumssikring, gulvvarme og fliser
- Montering af bruseniche, toilet, håndvask, badekar og armaturer
- Dokumentation til forsikring og ejendomsmægler

## Hvad koster et nyt badeværelse?

Prisen afhænger af størrelse, materialevalg og hvor meget der skal flyttes rundt på installationerne – og den varierer derfor fra opgave til opgave. Vælger du at beholde placeringen af toilet og afløb, sparer du typisk både tid og penge. Vi kommer gerne ud, ser på badeværelset og giver dig et [uforpligtende tilbud](/tilbud) med fast pris.

## Sådan forløber en badeværelsesrenovering

1. **Besigtigelse og skitse** Vi måler op, taler om ønsker og foreslår en indretning, der udnytter pladsen.
2. **Tilbud med fast pris** Du får et samlet tilbud på alle fag med tidsplan.
3. **Nedrivning og installationer** Nye rør, afløb, gulvvarme og vådrumssikring.
4. **Fliser og montering** Murer lægger fliser, og vi monterer sanitet og armaturer.
5. **Aflevering** Gennemgang, rengøring og dokumentation.

## Badeværelser i Billund, Grindsted, Give og Vejle

Vi renoverer badeværelser i hele Billund Kommune og omegn. Se eksempler på færdige badeværelser under [referencer](/referencer), eller læs om, hvad vi ellers kan hjælpe med inden for [VVS-arbejde](/vvs).

Kan I flytte toilettet til en anden væg?

Ja, i de fleste tilfælde. Det kræver nyt afløb og ofte ophugning af gulvet, hvilket påvirker prisen. Vi vurderer det ved besigtigelsen.

Hvor lang tid tager en badeværelsesrenovering?

En totalrenovering tager typisk 3–5 uger. Vi aftaler en tidsplan, inden vi går i gang, og sørger for, at du har adgang til toilet undervejs.

Kan jeg få håndværkerfradrag?

Arbejdslønnen til VVS-arbejde kan i mange tilfælde være berettiget til servicefradrag. Vi specificerer arbejdsløn og materialer på fakturaen, så du nemt kan indberette det.`
};
